/* Majestiq — formulaire produit : bouton d'achat + sélecteur de packs + prix barré du total panier. Chargé depuis layout/theme.liquid (écouteurs sur document, survivent à la navigation morph). NB: un champ caché name="id" masque form.id, donc on lit getAttribute('id'). */
(function () {
  if (window.__mqNativeSync) return;
  window.__mqNativeSync = true;
  var variants = null;
  function getVariants() {
    if (variants) return variants;
    var data = document.querySelector('[data-mq-variants]');
    if (!data) return null;
    try { variants = JSON.parse(data.textContent); } catch (e) { variants = null; }
    return variants;
  }
  function currentVariant() {
    var vs = getVariants(); if (!vs) return null;
    var picker = document.querySelector('variant-picker');
    if (picker) {
      var sel = [];
      picker.querySelectorAll('fieldset.variant-option, .variant-option--dropdowns').forEach(function (fs) {
        var i = fs.querySelector('input[type=radio]:checked');
        var s = fs.querySelector('select');
        sel.push(i ? i.value : (s ? s.value : null));
      });
      if (sel.length) {
        for (var k = 0; k < vs.length; k++) {
          var ok = true;
          for (var j = 0; j < sel.length; j++) { if (sel[j] !== null && vs[k].options[j] !== sel[j]) { ok = false; break; } }
          if (ok) return vs[k];
        }
      }
    }
    try {
      var id = new URL(window.location.href).searchParams.get('variant');
      if (id) for (var m = 0; m < vs.length; m++) if (String(vs[m].id) === id) return vs[m];
    } catch (e) {}
    return null;
  }
  function sync() {
    var v = currentVariant(); if (!v) return;
    var idIn = document.querySelector('[data-mq-variant-id]');
    var btn = document.querySelector('[data-mq-atc]');
    var lab = document.querySelector('[data-mq-btn-label]');
    if (idIn && idIn.value !== String(v.id)) idIn.value = v.id;
    if (btn) {
      if (btn.disabled !== !v.available) btn.disabled = !v.available;
      var txt = v.available ? (btn.getAttribute('data-label-add') || 'Ajouter au panier') : (btn.getAttribute('data-label-out') || 'Épuisé');
      if (lab && lab.textContent !== txt) lab.textContent = txt;
    }
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-picker')) { setTimeout(sync, 0); setTimeout(sync, 400); setTimeout(sync, 1200); }
  });
  document.addEventListener('submit', function (e) { if (e.target && e.target.getAttribute && e.target.getAttribute('id') === 'mq-pdp-form') sync(); }, true);
  document.addEventListener('pointerdown', function (e) { if (e.target && e.target.closest && e.target.closest('[data-mq-atc]')) sync(); }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  document.addEventListener('shopify:section:load', sync);
})();

(function(){
  if(window.__mqPacks) return; window.__mqPacks=true;
  function $(s,r){ return (r||document).querySelector(s); }
  function $$(s,r){ return [].slice.call((r||document).querySelectorAll(s)); }
  function root(){ return $('[data-mq-packs]'); }
  /* Sur les pages sans sélecteur de packs (ex. Pack Trio), on laisse l'ajout au panier natif. */
  function hasPacks(){ var r=root(); return !!(r && $$('input[data-mq-pack]',r).length); }
  var selectedId=null;
  function selectedInput(){
    var r=root(); if(!r) return null;
    var inputs=$$('input[data-mq-pack]',r); if(!inputs.length) return null;
    if(selectedId){
      for(var i=0;i<inputs.length;i++){ if(inputs[i].dataset.mqPackBlockId===selectedId) return inputs[i]; }
    }
    for(var j=0;j<inputs.length;j++){ if(inputs[j].checked) return inputs[j]; }
    return inputs[0];
  }
  function vars(){ var n=$('[data-mq-variants]'); if(!n) return []; try{ return JSON.parse(n.textContent); }catch(e){ return []; } }
  function forced(){ var r=root(); return ((r&&r.dataset.soldout)||'').toLowerCase().split(',').map(function(s){return s.trim();}).filter(Boolean); }
  function find(vs,vals){ if(!vs||!vs.length) return null; for(var i=0;i<vs.length;i++){ var ok=true; for(var j=0;j<vals.length;j++){ if(vs[i].options[j]!==vals[j]){ ok=false; break; } } if(ok) return vs[i]; } return null; }
  function unitVals(u){ var vals=[]; $$('select[data-mq-pu]',u).forEach(function(s){ vals[+s.dataset.pos-1]=s.value; }); return vals; }
  function packVarsFor(pid){
    if(!pid) return vars();
    var n=$('[data-mq-pack-variants][data-pid="'+pid+'"]');
    if(!n) return vars();
    try{ var parsed=JSON.parse(n.textContent); return (Array.isArray(parsed) && parsed.length) ? parsed : vars(); }catch(e){ return vars(); }
  }
  function packVarsFor2(pid){
    if(!pid) return null;
    var n=$('[data-mq-pack-variants2][data-pid="'+pid+'"]');
    if(!n) return null;
    try{ var parsed=JSON.parse(n.textContent); return (Array.isArray(parsed) && parsed.length) ? parsed : null; }catch(e){ return null; }
  }
  function isColorSelect(s){ return [].some.call(s.options,function(o){ return o.hasAttribute('data-img'); }); }
  /* La photo principale suit la couleur choisie dans n'importe quelle ligne de pack (1, 2 ou 3 T-shirts) : on coche la pastille ronde correspondante. */
  function syncMainColor(select){
    if(!isColorSelect(select)) return;
    var val=select.value;
    var radios=$$('variant-picker fieldset.mq-color input[type=radio]');
    var radio=null;
    for(var i=0;i<radios.length;i++){ if(radios[i].value===val){ radio=radios[i]; break; } }
    if(radio && !radio.checked){ radio.checked=true; radio.dispatchEvent(new Event('change',{bubbles:true})); }
  }
  function refreshUnit(u){
    var vs=vars(), fl=forced(), sels=$$('select[data-mq-pu]',u), r=root(), offLbl=(r&&r.dataset.off)||'épuisé';
    sels.forEach(function(s){
      var o=s.options[s.selectedIndex];
      if(o && fl.indexOf(o.value.toLowerCase())>-1){ for(var i=0;i<s.options.length;i++){ if(fl.indexOf(s.options[i].value.toLowerCase())<0){ s.selectedIndex=i; break; } } }
    });
    var vals=unitVals(u);
    sels.forEach(function(s){
      var p=+s.dataset.pos-1;
      for(var i=0;i<s.options.length;i++){
        var o=s.options[i], t=vals.slice(); t[p]=o.value; var v=find(vs,t);
        var off=fl.indexOf(o.value.toLowerCase())>-1 || !(v&&v.available);
        if(!o.hasAttribute('data-l')) o.setAttribute('data-l',o.textContent);
        o.disabled=off; o.textContent=o.getAttribute('data-l')+(off?' — '+offLbl:'');
      }
      var img=s.parentNode.querySelector('.mq-pk__cimg');
      if(img){ var so=s.options[s.selectedIndex], src=so&&so.getAttribute('data-img'); if(src){ img.src=src; img.hidden=false; } else { img.hidden=true; } }
    });
  }
  function state(){
    var inp=selectedInput(), card=inp&&inp.closest('.mq-pk');
    var units=card?$$('.mq-pk__unit',card):[];
    if(!units.length) return {items:null};
    var bid=inp&&inp.dataset.mqPackBlockId;
    var vs1=packVarsFor(bid), vs2=packVarsFor2(bid);
    var map={}, ok=true, firstVals=null;
    units.forEach(function(u,idx){
      var vals=unitVals(u), v;
      if(idx===0){
        firstVals=vals;
        v=find(vs1,vals);
        if(!v||!v.available){ ok=false; } else { map[v.id]=(map[v.id]||0)+1; }
        return;
      }
      var same = firstVals && vals.length===firstVals.length && vals.every(function(val,i){ return val===firstVals[i]; });
      if(same){ v=find(vs1,vals); }
      else { v=find((vs2 && vs2.length) ? vs2 : vs1,vals); }
      if(!v||!v.available){ ok=false; } else { map[v.id]=(map[v.id]||0)+1; }
    });
    return {items:map, ok:ok};
  }
  function applyBtn(){
    var st=state(); if(!st.items) return;
    var btn=$('[data-mq-atc]'), lab=$('[data-mq-btn-label]');
    if(btn) btn.disabled=!st.ok;
    if(lab && btn) lab.textContent=st.ok?(btn.getAttribute('data-label-add')||'Ajouter au panier'):(btn.getAttribute('data-label-out')||'Épuisé');
  }
  function sync(){
    var r=root(); if(!r) return;
    var inputs=$$('input[data-mq-pack]',r); if(!inputs.length) return;
    var sel=selectedInput(); if(!sel) return;
    if(!selectedId) selectedId=sel.dataset.mqPackBlockId;
    var q=$('[data-mq-qty]');
    inputs.forEach(function(i){
      var on=(i.dataset.mqPackBlockId===selectedId);
      if(i.checked!==on) i.checked=on;
      var c=i.closest('.mq-pk'); if(c) c.classList.toggle('is-on',on);
      if(on && q) q.value=i.value;
    });
    $$('.mq-pk__unit',r).forEach(refreshUnit);
    applyBtn();
  }
  function msg(t){ var m=$('[data-mq-packmsg]'); if(!m) return; m.textContent=t||''; m.hidden=!t; }
  document.addEventListener('change',function(e){
    var t=e.target; if(!t||!t.matches) return;
    if(t.matches('input[data-mq-pack]')){ msg(''); selectedId=t.dataset.mqPackBlockId; sync(); }
    else if(t.matches('select[data-mq-pu]')){ msg(''); var u=t.closest('.mq-pk__unit'); if(u) refreshUnit(u); applyBtn(); syncMainColor(t); }
  });
  document.addEventListener('click',function(e){
    var lbl=e.target&&e.target.closest&&e.target.closest('.mq-pk');
    if(!lbl) return;
    var inp=lbl.querySelector('input[data-mq-pack]');
    if(!inp) return;
    if(selectedId!==inp.dataset.mqPackBlockId){ msg(''); selectedId=inp.dataset.mqPackBlockId; sync(); }
  },true);
  document.addEventListener('mq:variant',applyBtn);
  function doAddToCart(){
    var st=state();
    var r=root(), errTxt=(r&&r.dataset.err)||"Impossible d'ajouter au panier.";
    /* Offres sans sélecteur de variantes (produit à variante unique) : on ajoute la variante courante × la quantité de l'offre choisie. */
    if(!st.items || !Object.keys(st.items).length){
      var sel=selectedInput(), vid=$('[data-mq-variant-id]'), qn=sel?(parseInt(sel.value,10)||1):1;
      if(sel && vid && vid.value){ st={items:{},ok:true}; st.items[vid.value]=qn; }
      else { msg(errTxt); return; }
    }
    if(!st.ok){ msg(errTxt); return; }
    var items=Object.keys(st.items).map(function(id){ return {id:+id,quantity:st.items[id]}; });
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(res){ if(!res.ok){ return res.json().then(function(j){ throw new Error(j.description||j.message||errTxt); }); } return res.json(); })
      .then(function(){ if(window.k9CartOpen){ window.k9CartOpen(); return; } var root_=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/'; window.location.href=root_+'cart'; })
      .catch(function(err){ msg(err&&err.message?err.message:errTxt); });
  }
  function isMqForm(f){ return f && f.getAttribute && f.getAttribute('id')==='mq-pdp-form' && hasPacks(); }
  document.addEventListener('click',function(e){
    var t=e.target&&e.target.closest&&e.target.closest('[data-mq-atc]');
    if(!t) return;
    var f=t.closest('form'); if(!isMqForm(f)) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    doAddToCart();
  },true);
  document.addEventListener('submit',function(e){
    if(!isMqForm(e.target)) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    doAddToCart();
  },true);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',sync); else sync();
  document.addEventListener('shopify:section:load',sync);
  document.addEventListener('shopify:block:select',sync);
})();

/* Panier : ancien prix (prix comparé x quantité) barré sous le total estimé */
(function(){
  if(window.__mqWas) return; window.__mqWas=true;
  var cache={}, timer=null;
  function prod(h){ return cache[h]||(cache[h]=fetch('/products/'+h+'.js').then(function(r){return r.json();})); }
  function run(){
    var tot=document.querySelector('.cart-totals__total'); if(!tot) return;
    var val=tot.querySelector('[data-testid="cart-total-value"]'); if(!val) return;
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      return Promise.all(c.items.map(function(it){ return prod(it.handle).then(function(p){
        var v=(p.variants||[]).filter(function(x){return x.id===it.variant_id;})[0];
        var u=it.price; if(v && v.compare_at_price && v.compare_at_price>u) u=v.compare_at_price;
        return u*it.quantity;
      }).catch(function(){ return it.original_line_price; }); })).then(function(a){
        var was=a.reduce(function(s,x){return s+x;},0), box=tot.parentNode, el=box.querySelector('.mq-cart-was');
        if(was<=c.total_price){ if(el) el.remove(); return; }
        var num=(was/100).toFixed(2).replace('.',','), txt=(val.textContent||'').trim().replace(/\d[\d\s.,]*\d/,num);
        if(!el){ el=document.createElement('span'); el.className='mq-cart-was'; el.style.cssText='display:block;text-align:right;text-decoration:line-through;opacity:.6;font-size:.95rem;margin-top:-2px'; tot.insertAdjacentElement('afterend',el); }
        if(el.textContent!==txt) el.textContent=txt;
      });
    }).catch(function(){});
  }
  function later(){ clearTimeout(timer); timer=setTimeout(run,300); }
  new MutationObserver(later).observe(document.documentElement,{childList:true,subtree:true,characterData:true});
  later();
})();
